import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { AbortableApiDataAccess, ApiDataAccess } from '@softline/core';
import { DocumentTypeRepository } from './repositories/document-type.repository';
import { SOFTLINE_PERMISSION_WWS_SALES } from './sales.shared';
import { DocumentFilterLabelStore } from './services/document-filter-label-store.service';
import { DocumentQueryFilterStateService } from './services/document-query-filter-state.service';
import { DocumentTypeService } from './services/document-type.service';
import { SalesDocumentFilterService } from './services/sales-document-filter.service';

/** Route-scoped providers for the document-query filter sidebar: abortable HTTP
 *  (so option loads can cancel on retype), the hybrid loader, and the selection
 *  state. Scoped to the query routes — not the whole sales tree — so the
 *  AbortableApiDataAccess override stays narrow. */
const documentQueryProviders = [
  { provide: ApiDataAccess, useClass: AbortableApiDataAccess },
  SalesDocumentFilterService,
  DocumentQueryFilterStateService,
  DocumentFilterLabelStore,
];

export const salesRoutes: Routes = [
  {
    path: 'sales',
    canActivate: [AuthenticationGuard],
    data: { permission: SOFTLINE_PERMISSION_WWS_SALES },
    providers: [
      { provide: DocumentTypeRepository, useClass: DocumentTypeRepository },
      DocumentTypeService,
    ],
    children: [
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
      },
      {
        path: 'overview',
        loadComponent: () =>
          import('./pages/overview/overview.component').then(
            (o) => o.SalesOverviewComponent
          ),
      },
      {
        path: 'document/create',
        loadComponent: () =>
          import('./pages/document/document.component').then(
            (m) => m.SalesDocumentComponent
          ),
      },
      {
        path: 'document/:documentId',
        loadComponent: () =>
          import('./pages/document/document.component').then(
            (m) => m.SalesDocumentComponent
          ),
      },
      {
        path: 'query/:documentType',
        providers: documentQueryProviders,
        loadComponent: () =>
          import('./pages/document-query/document-query.component').then(
            (m) => m.DocumentQueryComponent
          ),
      },

      {
        path: 'query',
        providers: documentQueryProviders,
        loadComponent: () =>
          import('./pages/document-query/document-query.component').then(
            (m) => m.DocumentQueryComponent
          ),
      },
      {
        path: 'config',
        loadComponent: () => import('./pages/config/sales-config.component'),
      },
    ],
  },
];
